var map = {
	"./0.png": 843,
	"./1.png": 844,
	"./10.png": 845,
	"./11.png": 846,
	"./12.png": 847,
	"./13.png": 848,
	"./14.png": 849,
	"./15.png": 850,
	"./16.png": 851,
	"./17.png": 852,
	"./18.png": 853,
	"./19.png": 854,
	"./2.png": 855,
	"./3.png": 856,
	"./4.png": 857,
	"./5.png": 858,
	"./6.png": 859,
	"./7.png": 860,
	"./8.png": 861,
	"./9.png": 862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 842;